<template>
  <div class="login">
    <Login />
  </div>
</template>

<script>
// @ is an alias to /src
import Login from "@/components/login.vue";

export default {
  name: "login",
  components: {
    Login
  }
};
</script>
<style scoped lang="scss">
.login {
  background-color: #fff;
  word-break: break-word;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  // background-image: url(../assets/d_bg.svg);
  // background-size: auto;
  // background-repeat: no-repeat;
  // background-position: left;
}
</style>
